import React, { Fragment } from 'react';

import { EirCustomerDetails } from './EirCustomerDetails';
import { EirAddressDetails } from './EirAddressDetails';
import { Paper } from '@material-ui/core';
import { EirSecurityQuestion } from './EirSecurityQuestion';
import { EirMarketingPreferences } from './EirMarketingPreferences';
import { EirDirectoryPreferences } from './EirDirectoryPreferences';
import { useStyle } from './style';
import { EirTermsNConditions } from './EirTermsNConditions';


export const EirRegisteredCustomer = (props) => {
    const classes = useStyle();
    const { customerInformation, directoryPreference, setDirectoryPreference } = props;

    return (
        <Fragment>
            <Paper elevation={3} className={classes.paper}>
                <EirCustomerDetails />
                <EirAddressDetails />
            </Paper>
            <Paper elevation={3} className={classes.paper}>
                <EirSecurityQuestion />
                <EirMarketingPreferences customerInformation={customerInformation}/>
                <EirDirectoryPreferences directoryPreference={directoryPreference}
                    setDirectoryPreference={setDirectoryPreference} />
                <EirTermsNConditions />
            </Paper>
        </Fragment>
    );


}
